export var FormType;

(function (FormType) {
  FormType["Normal"] = "normal";
  FormType["Global"] = "global";
})(FormType || (FormType = {}));